import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faTrash, faBookmark, faNewspaper, faHeartRate, faDotCircle, faCircle, faShare, faArrowToBottom } from '@fortawesome/pro-light-svg-icons';
import { faCaretDown, faBookmark as fasBookmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faSearch, faCaretDown, faTrash, faBookmark, fasBookmark, faNewspaper, faHeartRate, faDotCircle, faCircle, faShare, faArrowToBottom);


Vue
  .use(BootstrapVue)
  .use(FontAwesomeIcon)
  .component('fa-icon', FontAwesomeIcon)
;
